import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function MaskedLine({ children, delay = 0, as: Tag = "span", className = "" }) {
  return (
    <span className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block will-change-transform"
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1.1, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function Reveal({ children, delay = 0, y = 48, className = "", ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function Overline({ children, className = "" }) {
  return (
    <p className={`font-sans font-semibold text-[11px] tracking-[0.3em] uppercase text-[#6F6F63] ${className}`}>
      {children}
    </p>
  );
}
